<template>
  <div>Verified Email!</div>
</template>
<script>
/* TODO: New Verified Email Design 
  Currently has temporary placeholder view to process email verification
*/

import { AUTH_VERIFY_EMAIL } from "@/store/types";

export default {
  data() {
    return {};
  },
  async mounted() {
    const { token } = this.$route.params;
    try {
      await this.$store.dispatch(AUTH_VERIFY_EMAIL, token);
      this.$router.push({ name: "analytics" });
    } catch (err) {
      console.log(err);
    }
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
</style>
